// @flow
import React from 'react';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { Small } from '@finect/tabular-core/Small';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';

type Props = {
  url: string,
  msg: string,
  center?: boolean
};

export const NotLoggedIn = ({ url, msg, center }: Props) => (
  <ParagraphSmall textCenter={center}>
    <Small light>
      <AppLink href={`${getLoginBaseURL()}/login?next=${url}`} rel="nofollow">
        Accede a Finect
      </AppLink>{' '}
      para poder {msg}.
    </Small>
  </ParagraphSmall>
);
